export default __webpack_public_path__ + "static/media/Logowhite_cropped.cd0912f5.png";